<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col class="mt-sm-20">
          <v-col class="rowq1">
            <div class="text-center">
              <h1>
                Navigating Maritime Excellence in AWS: Maritech's Tailored Cloud
                Consulting and Solutions
              </h1>
            </div>
          </v-col>
          <v-col md="6" lg="6" sm="12" align-self="center" class="mx-auto">
            <v-img :src="require('@/assets/saas-concept-collage.jpg')" />
          </v-col>
          <v-col>
            <div class="text-center">
              <p>
                Welcome aboard the future of Maritime IT solutions! Maritech
                Software Solutions is thrilled to announce the launch of our
                cutting-edge AWS consulting services tailored specifically for
                maritime companies. Embark on a transformative journey with us
                as we elevate your operations through continuous monitoring,
                strategic architecting, cost control, and optimization, along
                with seamless workload migration to the cloud.
              </p>
            </div>
          </v-col>
          <v-row class="pt-5">
            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-calendar-search
              </v-icon>
              <h3>
                Continuous Monitoring for Unmatched Operational Resilience
              </h3>
              <br />
              Ensure the highest level of operational resilience with our
              continuous monitoring solutions. We leverage AWS tools to provide
              real-time insights into your maritime operations, allowing you to
              proactively identify and address potential issues before they
              impact your business. Stay ahead of the curve with our
              state-of-the-art monitoring capabilities.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-account-hard-hat
              </v-icon>
              <h3>Architecting the Future of Maritime IT</h3>
              <br />
              Redefine your maritime IT infrastructure with our expert
              architects who specialize in AWS solutions. We design and
              implement scalable, secure, and high-performance architectures
              that align perfectly with the unique demands of the maritime
              industry. Elevate your digital presence and streamline your
              operations with our innovative architectural solutions.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-currency-usd
              </v-icon>
              <h3>Cost Control and Optimization (Right Sizing)</h3>
              <br />
              Sail into cost-efficient waters with Maritech's AWS consulting.
              Our experts meticulously analyze your cloud usage, ensuring that
              you only pay for what you need. Through right sizing and
              optimization strategies, we help you achieve optimal performance
              at minimal costs. Let us navigate your budget with precision and
              effectiveness.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-cloud
              </v-icon>
              <h3>Seamless Workload Migration to the Cloud</h3>
              <br />
              Experience a smooth transition to the cloud with our expert
              migration services. We understand the intricacies of maritime
              workloads and ensure a hassle-free migration process, minimizing
              downtime and maximizing efficiency. Whether you're moving from
              on-premises solutions or another cloud provider, trust Maritech
              for a seamless and secure migration experience.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-help
              </v-icon>
              <h3>Why Choose Maritech?</h3>
              <ul>
                <li>
                  <b>Industry Expertise:</b> Decades of experience in both
                  maritime and AWS domains.
                </li>
                <li>
                  <b>Tailored Solutions:</b> Customized strategies to meet the
                  unique needs of maritime businesses.
                </li>
                <li>
                  <b>Cost Efficiency:</b> Optimize your cloud expenses without
                  compromising performance.
                </li>
                <li>
                  <b>Reliability:</b> Rely on our continuous monitoring for a
                  resilient and secure maritime IT environment.
                </li>
                <li>
                  <b>Efficient Migration:</b> Smooth and efficient workload
                  migration to the AWS cloud.
                </li>
              </ul>
            </v-col>
          </v-row>
          <br />
          <p class="text-center">
            <strong>
              Transform your maritime operations with Maritech Software
              Solutions. Contact us today to embark on a journey towards IT
              excellence in the maritime industry. Your voyage to digital
              transformation begins here!</strong
            >
          </p>
          <v-row justify="center">
            <v-col sm="12" md="5" lg="5">
              <div>
                <base-request />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Navigating Maritime Excellence in AWS";
  }
};
</script>
<style scoped>
@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
